<template>
  <div style="text-align:center;" id="main">
    <h1>{{ $t("404.title") }}</h1>
    <h2>404</h2>
    <img src="https://http.cat/404.jpg" width="300" />
  </div>
</template>

<script>
export default {
  name: "notfound",
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.path = this.$route.path;
  },
  methods: {},
  components: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// 404.vue?1c3606cc